import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { DialogFWIntegrationForm } from "../../components/DialogFWIntegrationForm/DialogFWIntegrationForm";

const IntegrationDialogFormWidgetScreen = () => {
  return (
    <ScreenLayout>
      <DialogFWIntegrationForm />
    </ScreenLayout>
  );
};

export default IntegrationDialogFormWidgetScreen;
